export default __webpack_public_path__ + "static/media/cx_cover_lnn2.196f04bf.jpg";